/**
 * Safely extracts '_embedded.self' from an unknown object, or else returns `null`.
 *
 * Intended for use with JSON data that has not yet been type-checked.
 */
export default function getEmbeddedSelfArray(data: unknown): Array<unknown> | null {
    if (
        !data ||
        typeof data !== 'object' ||
        Array.isArray(data) ||
        !('_embedded' in data) ||
        !data._embedded ||
        typeof data._embedded !== 'object' ||
        !('self' in data._embedded) ||
        !data._embedded.self ||
        !Array.isArray(data._embedded.self)
    ) {
        return null
    }

    return data._embedded.self
}
